module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mgDKcs/media/FC-9789948825753.jpg?1684514529074",
      "alt": "This image is the cover for the book دفتر المذكِّرات"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("دفتر المذكِّرات\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("بعد خمس عشرة سنة في الغيبوبة، تستيقظ تالا على عالم غريب، لا تعرف أحداً فيه غير والدة لم تتركها لحظة، وحبيب سابق نجا بأعجوبة من حادث كان ضحيته قتيلان وتالا. في قلب فتاة في الخامسة عشرة ستختبر تالا الحب والخيبات في جسد امرأة في الثلاثين. ستتصارع مع ذكرياتها وحب قديم متزوّج لا تستطيع التّخلّي عنه، مع خطر حقبة لا تفهم ألاعيبها، وفرصة حياة ثانية قد تفوتها.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      ريزا ميشال داود\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("ريزا ميشال داود، وُلِدَت في بيروت ١٩٨١، بدأَتِ العمل في سنٍّ مبكرة في مجالات عديدة وهي تكمل دراستها.  درَسَتِ التمثيل ومِن بعدها انتقلَت إلى العمل في كواليس التليفزيون، وتنوَّعَت أعمالها بين برامج الهواة، ومسلسلات وأفلام سينمائيَّة ووثائقيَّة، وقد قرَّرَتِ الانتقال إلى شغفها الأوَّل.. الكتابة. وهي أمٌّ لولدَين، وتعيش حاليًا في الإمارات العربيَّة المتحدة، ولها كتاب بعنوان \"لو يعود\".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0